export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";